import { API_ENDPOINTS } from '../config/api';

const API_BASE = API_ENDPOINTS.auth;

class AuthService {
  static async login(email, password) {
    // Get guest shortlist data before login
    const guestShortlist = this.getGuestShortlist();
    
    const response = await fetch(`${API_BASE}/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        email, 
        password,
        guestShortlist // Send guest data with login
      })
    });
    
    const data = await response.json();
    
    if (response.ok && data.success) {
      // Clear guest shortlist after successful migration
      this.clearGuestShortlist();
      
      if (data.migratedItems > 0) {
        console.log(`✅ Migrated ${data.migratedItems} items from guest shortlist`);
      }
    }
    
    return data;
  }

  static async register(name, email, password) {
    const response = await fetch(`${API_BASE}/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, email, password })
    });
    return response.json();
  }

  static async verifyToken() {
    const token = localStorage.getItem('token');
    if (!token) return null;

    try {
      const response = await fetch(`${API_BASE}/verify`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        return data.user;
      } else {
        localStorage.removeItem('token');
        return null;
      }
    } catch (error) {
      localStorage.removeItem('token');
      return null;
    }
  }

  static async logout() {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        await fetch(`${API_BASE}/logout`, {
          method: 'POST',
          headers: { 'Authorization': `Bearer ${token}` }
        });
      } catch (error) {
        console.log('Logout request failed:', error);
      }
    }
    localStorage.removeItem('token');
  }

  static getToken() {
    return localStorage.getItem('token');
  }

  static isAuthenticated() {
    return !!localStorage.getItem('token');
  }

  // Guest shortlist management
  static getGuestShortlist() {
    const stored = localStorage.getItem('guestShortlist');
    return stored ? JSON.parse(stored) : [];
  }

  static addToGuestShortlist(vendorData) {
    const guestShortlist = this.getGuestShortlist();
    if (!guestShortlist.find(v => v.id === vendorData.id)) {
      guestShortlist.push(vendorData);
      localStorage.setItem('guestShortlist', JSON.stringify(guestShortlist));
    }
  }

  static removeFromGuestShortlist(vendorId) {
    const guestShortlist = this.getGuestShortlist();
    const filtered = guestShortlist.filter(v => v.id !== vendorId);
    localStorage.setItem('guestShortlist', JSON.stringify(filtered));
  }

  static clearGuestShortlist() {
    localStorage.removeItem('guestShortlist');
  }
}

export default AuthService;
